
import React, { useState } from 'react';
import styled from 'styled-components';
import AnnotationView from './components/AnnotationView';
import ViewerMode from './components/ViewerMode';

const AppContainer = styled.div`
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  height: 100vh;
  display: flex;
  flex-direction: column;
`;

const Header = styled.header`
  background-color: #2c3e50;
  color: white;
  padding: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Title = styled.h1`
  margin: 0;
  font-size: 1.5rem;
`;

const Nav = styled.nav`
  display: flex;
  gap: 1rem;
`;

const NavButton = styled.button`
  background: ${props => props.active ? '#3498db' : 'transparent'};
  color: white;
  border: 1px solid #3498db;
  padding: 0.5rem 1rem;
  cursor: pointer;
  border-radius: 4px;
  font-size: 1rem;

  &:hover {
    background: #2980b9;
  }
`;

const Content = styled.main`
  flex: 1;
  overflow: hidden;
  position: relative;
`;

function App() {
  const [mode, setMode] = useState('viewer'); // 'viewer' or 'annotation'
  const [tractate, setTractate] = useState('Berakhot');

  return (
    <AppContainer>
      <Header>
        <Title>Tosefta Parallel Workbench</Title>
        <Nav>
          <NavButton 
            active={mode === 'viewer'} 
            onClick={() => setMode('viewer')}
          >
            Viewer Mode
          </NavButton>
          <NavButton 
            active={mode === 'annotation'} 
            onClick={() => setMode('annotation')}
          >
            Annotation Mode
          </NavButton>
        </Nav>
      </Header>
      
      <Content>
        {mode === 'viewer' ? (
          <ViewerMode tractate={tractate} onTractateChange={setTractate} />
        ) : (
          <AnnotationView tractate={tractate} onTractateChange={setTractate} />
        )}
      </Content>
    </AppContainer>
  );
}

export default App;
